export const environment = {
  baseUrl: 'https://backend.dev.servicenmaintenance.com/api/',
  socketUrl: 'https://backend.dev.servicenmaintenance.com',
  backendSecretKey: 'KUNU-VolkovIndia-7777',
  localStorageSecretKey: 'beautiful129*876 Rashmi',
  developerUrl: '/developer',
  adminUrl: '/admin',
  superAdminUrl: '/super-admin',
  acccountManagerUrl: '/account-manager',
  areaManagerUrl: '/area-manager',
  salesManagerUrl: '/sales-manager',
  salesExecutiveUrl: '/sales-executive',
  serviceEngineerUrl: '/service-engineer',
  providerUrl: '/provider',
  appUrl: 'https://dev.servicenmaintenance.com',
  clientId: 'bd091fbf-62ce-4e40-a56e-f173b3d78a36',
  allowed_countries: ['UK', 'IE', 'AT', 'BE', 'FR', 'DE', 'NL', 'PL'],
  authority: 'https://login.microsoftonline.com/4d2f2674-4fb2-4849-87f4-a7f7140172cc',
  guestUrl: '/guest',
  googlePlaceApiKey: 'AIzaSyAUc5KPygalKXNqkFmLtyL0ZurvXTl4mGM',
  aws: {
    region: 'eu-west-1',
    accessKeyId: 'AKIAUSB2PDKVZLKQN47E',
    secretAccessKey: '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',
    bucketName: 'amie2.0',
    folders: {
      emailNotifications: 'email-notifications/',
      courseQuestions: 'course-questions/',
      general: 'uploads/'
    }
  }
};
